<form [formGroup]="dynamicForm" (ngSubmit)="onSubmit()" class="w-full">
  <formly-form [form]="dynamicForm" [fields]="form()?.fields" [model]="model()"></formly-form>
</form>

<div class="flex flex-row justify-around">
  <button pButton [disabled]="!dynamicForm.valid" (click)="onSubmit()">{{ (actionText() || form()?.actionText || 'button.save') | translate}}</button>
  @if(closeButton()) {
    <button pButton severity="secondary" (click)="onClose()">{{ 'button.close' | translate }}</button>
  }
</div>
